import React, { useState } from "react";
import { Tabs, Tab, makeStyles, CircularProgress } from "@material-ui/core";
import { getBrokerInformation } from "../../store/broker";
import { useDispatch, useSelector } from "react-redux";
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme) => ({
  tabs: {
    overflow: "visible",
    maxWidth: "32%",
    maxHeight: "100%",
    "& .MuiButtonBase-root.MuiTab-root": {
      borderBottom: "1px solid #6c757d",
      borderRadius: "24px",
      marginBottom: ".5rem",
      "&:hover": {
        background: "#E1E5EA",
      },
    },
    "& .MuiTab-labelIcon": {
      minHeight: "3rem",
      padding: "0 1rem",
    },
    ".MuiTab-labelIcon .MuiTab-wrapper > *:first-child": {
      marginBottom: "none",
    },
    "& .Mui-selected": {
      backgroundColor: "#696969 !important",
      color: "#fff",
      boxShadow: "0 0 2px #3F445A",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTab-wrapper": {
      display: "flex",
      alignItems: "center",
      flexDirection: "row-reverse",
      textAlign: "start",
    },
  },
}));

// Helper function to get all cover values from a card, regardless of its structure
const getCoverValues = (card) => {
  // If the card is an array, return it directly
  if (Array.isArray(card)) return card;

  // If the card is an object (with buildings), combine all arrays into one
  return Object.values(card).flat();
};

const BasicTab = ({ buffer, setBuffer, cardsObject, setTitle, covertypes }) => {
  const classes = useStyles();
  const handleChange = (event, newValue) => {
    setBuffer(newValue);
  };
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;

  return (
    <Tabs
      orientation="vertical"
      variant="scrollable"
      value={buffer}
      onChange={handleChange}
      aria-label="Vertical tabs example"
      className={classes.tabs}
    >
      {Object.keys(cardsObject).map((key, index) => {
        if (key == "RESPONSE") return <></>;
        else {
          // const card = cardsObject[key];
          const card = getCoverValues(cardsObject[key]);
          const value = card.filter(
            (cover) => cover.covervalue && cover.covervalue !== ""
          );
          let inProgress;
          if (value.length !== 0) {
            inProgress = value[0]?.covertypecode;
          } else inProgress = null;
          return covertypes?.map((item) => {
            if (
              item.code === key ||
              (item.code === "LOCATION" &&
                key.toUpperCase().includes(item.code))
            ) {
              return (
                <Tab
                  label={
                    item.code != "LOCATION"
                      ? item.name[languagepreference]
                      : key
                  }
                  onClick={() => {
                    item.code != "LOCATION"
                      ? setTitle(item.name[languagepreference])
                      : setTitle("key");
                  }}
                  {...a11yProps(index)}
                  icon={
                    <CircularProgress
                      size="1.325rem"
                      style={{
                        color: `${
                          key == inProgress ||
                          key.toUpperCase().includes(inProgress)
                            ? value.length == card.length
                              ? "#0F9D58"
                              : "#F25022"
                            : "#3F445A"
                        }`,
                        marginLeft: "auto",
                      }}
                      variant="determinate"
                      value={
                        key == inProgress ||
                        key.toUpperCase().includes(inProgress)
                          ? value.length == card.length
                            ? "100"
                            : "50"
                          : "0"
                      }
                    />
                  }
                />
              );
            }
          });
        }
      })}
    </Tabs>
  );
};

export default BasicTab;
